<div class="dev-comment">src\app\landowner-admin-shared\components\season-lookup-form\season-lookup-form.component.html</div>

<div *ngIf="value" class="flx-container">
  <ng-container *ngIf="showTitle">
    <div class="flx-item title">Season Lookup</div>

    <div class="flx-break"></div>
  </ng-container>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Name</label>
    <oapopover class="oa-popover" [title]="'Seasonal Lookup Name'" [content]="'A short name that describes the season lookup.'"></oapopover>
  </div>

  <div class="flx-item-vertical-center">
    <input
      type="text"
      name=""
      id="season-lookup-name-input"
      class="form-control"
      value=""
      required="required"
      pattern=""
      title=""
      [(ngModel)]="value.name"
    />
  </div>

  <div class="flx-break"></div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Secure Alternate ID</label>
    <oapopover class="oa-popover" [title]="'Secure Alternate ID'" [content]="'A uuid unique identifer for the season lookup'"></oapopover>
  </div>

  <div id="secureAlternateId-text" class="flx-item-vertical-center text-muted">
    <!-- <input disabled type="text" name="secureAlternateId" id="input-secureAlternateId" class="form-control"required="required" pattern="" title="" [(ngModel)]="value.secureAlternateId" /> -->

    {{ value.secureAlternateId }}
  </div>

  <div class="flx-break"></div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Created On</label>
  </div>

  <div class="flx-item-vertical-center">
    <!-- <input disabled type="text" name="secureAlternateId" id="input-secureAlternateId" class="form-control"required="required" pattern="" title="" [(ngModel)]="value.secureAlternateId" /> -->

    {{ value.createdOn | date: "short" }}
  </div>

  <div class="flx-break"></div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="name">Created By</label>
  </div>

  <div class="flx-item-vertical-center">
    <!-- <input disabled type="text" name="secureAlternateId" id="input-secureAlternateId" class="form-control"required="required" pattern="" title="" [(ngModel)]="value.secureAlternateId" /> -->

    {{ value.createdBy | username | async }}
  </div>

  <div class="flx-break"></div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="startDateTime">Start Date:</label>
  </div>

  <div class="flx-item-vertical-center">
    <oadate-input *ngIf="value" [name]="'startDateTime'" [(value)]="value.startDateTime"> </oadate-input>
  </div>

  <div class="flx-item-vertical-center flex-col1">
    <label for="endDateTime">End Date:</label>
  </div>

  <div class="flx-item-vertical-center">
    <oadate-input *ngIf="value" [name]="'endDateTime'" [(value)]="value.endDateTime"> </oadate-input>
  </div>

  <div class="flx-break"></div>

  <!-- Only shown for Global and State SeasonLookups -->
  <!-- BEGIN State SELECT Component Group -->
  <ng-container *ngIf="!listingId">
    <div class="flx-divider"></div>
    <div class="flx-break"></div>

    <div class="flx-item-vertical-center flex-col1">
      <label for="endDateTime">State:</label>
    </div>

    <div class="flx-item-vertical-center">
      <select id="state-input" class="form-control select-box" autocomplete="region" [(ngModel)]="selectedState">
        <option disabled selected value="null">-- Select State --</option>

        <option *ngFor="let m of states" [ngValue]="m" [selected]="selectedState && m.id === selectedState.id">{{ m.id }}</option>
      </select>
    </div>

    <div class="flx-break"></div>
  </ng-container>
  <!-- END State SELECT Component Group -->

  <div *ngIf="!isNew" class="flx-item-vertical-center">
    <span> Tags: </span>
    <span>
      <tag-picker [names]="tagNames" (selected)="onSelectTag($event)"> </tag-picker>
    </span>
    <span>
      <entity-tag-cloud #entityTagCloud [entityName]="'SeasonLookup'" [entityId]="value.id" (delete)="onTagDelete($event)">
      </entity-tag-cloud>
    </span>
  </div>

  <div class="flx-break"></div>

  <div class="flx-item">
    <button
      [disabled]="!canSave"
      id="season-lookup-form-save-button"
      class="btn btn-primary btn-round hvr-push el-100px"
      (click)="onSaveClick()"
    >
      Save
    </button>

    <button id="season-lookup-form-cancel-button" class="btn btn-primary btn-round hvr-push el-100px" (click)="onCancelClick()">
      Cancel
    </button>
  </div>
</div>
